import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgTag(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M10.34 0a.963.963 0 01.68.282l8.666 8.666a.963.963 0 01.002 1.359l-5.38 5.41a.964.964 0 01-1.364 0L4.28 7.021A.963.963 0 014 6.34V.963A.963.963 0 014.963 0zM7.37 1.925a1.444 1.444 0 100 2.888 1.444 1.444 0 000-2.888z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Tag')(SvgTag);
